import { mimSupportedAttachmentTypes } from './mimDraftAttachments';

const mimDraftFailureMessage: Record<string, string> = {
  unsupported_message: `Mim can't read one of this conversation's attachments. It only supports ${mimSupportedAttachmentTypes}.`,
  prompt_injection:
    'Mim stopped drafting because the conversation looks like a prompt injection attempt.',
  blocked_by_content_policy:
    'Mim stopped drafting because the conversation was blocked by its content policy.',
  unable_to_handle:
    "Mim couldn't handle this conversation. Try drafting with another agent.",
  handoff_failed: "Mim couldn't draft a reply for this conversation.",
  unknown: "Mim couldn't draft a reply. Please try again.",
};

/** The message for a failed agent run's exit reason. */
export const getMimDraftFailureMessage = (exitReason?: string | null): string =>
  (exitReason && mimDraftFailureMessage[exitReason.toLowerCase()]) ||
  mimDraftFailureMessage.unknown;

/** The reason shown on a draft action that cannot run yet. */
export const unsupportedAttachmentReason =
  "Mim can't read this conversation's attachments";
